// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_DeleteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_DeleteResponse — result of POST /franchisor-channels/delete.
 * SUCCESS ONLY — the 'channel_has_enabled_bindings' refusal leaves the
 * controller through sendError(), never carrying a failure flag in here.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface FranchisorChannels_DeleteResponseDados {
id: number
deleted: boolean
}

export type FranchisorChannels_DeleteResponse = ApiResponse<FranchisorChannels_DeleteResponseDados>;

registerResponseContract('FranchisorChannels_DeleteResponse', {
  id:      { type: 'number',  required: true },
  deleted: { type: 'boolean', required: true },
})
